import {
    Paper,
    Table,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    Typography,
  } from "@mui/material";
import { FC, useEffect, useMemo, useState } from "react";
import { useMutation } from "react-query";
import { EmrListParams,EmrListType,initialSearchParams } from "../../../EMR/EmrLanding/types";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { getEmrList } from "../../../EMR/services";
import { base } from "../../../constants";
import debounce from "../../../utilis/methods/networkHandling";
import useAuthentication from "../../../hooks/useAuthentication";
import CustomTableBody from "../../../utilis/component/CustomTableBody";
import { FormOnChangeEventType } from "../../../EMR/types";
import { CustomFormField } from "../../../utilis/component/CustomFormElement";

  // import TaskAltIcon from "@mui/icons-material/TaskAlt";
  const TriageLandingPage: FC<{ path?: string }> = ({ path }) => {
    const navigateTo = useNavigate();
    const { user } = useAuthentication();
    const {pathname}=useLocation()
    const inEmr = path == `${base}ui/react/main/patient-care/emr/`;
    const [searchParams, setSearchParams] = useState<EmrListParams>({
      ...initialSearchParams,
      userType: user?.groupId,
    });
    const { mutate, data, isLoading } = useMutation(getEmrList);
    const { control, setValue } = useForm();
  
    const handleSearch = (e: FormOnChangeEventType) => {
      const { name, value } = e.target;
      const filter = {
        ...searchParams.filter,
        [name]: value,
      };
      if (filter.searchText == "") {
        delete filter.searchText;
      }
      setSearchParams({
        ...searchParams,
        filter,
      });
    }
    
    const onChange = debounce(handleSearch,500) ;
    const handleNavigate = (patient: EmrListType) => {
      navigateTo(`${pathname}/${patient.encounterID}?emrno=${patient?.emrNo}`);
    };
    const handleChangePage = (_: unknown, pageNumber: number) => {
      setSearchParams({
        ...searchParams,
        pageNumber,
      });
    };
    const handleChangeRowsPerPage = (
      event: React.ChangeEvent<HTMLInputElement>
    ) => {
      const pageSize = parseInt(event.target.value, 10);
      setSearchParams({
        ...searchParams,
        pageSize,
      });
    };
  
    const list = useMemo(() => {
      if (data?.response.psearchResponses) {
        return data.response.psearchResponses;
      } else {
        return [];
      }
    }, [data?.response]);
  
    useEffect(() => {
      setValue("searchDate", initialSearchParams.filter.searchDate);
    }, []);
  
    useEffect(() => {
      mutate(searchParams);
    }, [searchParams]);
    return (
      <div className="px-3 pt-4">
        <Paper className="flex flex-col gap-2">
          <TableContainer className=" relative ">
            <div className="px-4 py-2 border-b">
              <Typography variant="h6">Registered Patients</Typography>
            </div>
            <form className="py-4 px-2 grid grid-cols-4 gap-2">
              <CustomFormField
                control={control}
                element="datepicker"
                fieldProps={{ label: "Search date" }}
                name="searchDate"
                rules={{ required: false, onChange }}
              />
              <CustomFormField
                control={control}
                element="input"
                fieldProps={{ label: "Search name" }}
                name="searchText"
                rules={{ required: false, onChange }}
              />
            </form>
            <Table size="small" aria-label="simple table" className="border-b">
              <TableHead
                sx={(theme) => ({
                  backgroundColor: theme.palette.primary.main,
                })}
                className="sticky w-full top-0 bg-inherit z-50"
              >
                <TableRow>
                  {heading.map((title, index) =>
                    title == "PAYMENT STATUS" ? (
                      inEmr && (<TableCell key={`${title}${index}`}  sx={(theme)=>({color:theme.palette.background.paper})}>
                        
                          <strong>{title}</strong>
                        </TableCell>
                      )
                    ) : (
                      <TableCell key={`${title}${index}`} sx={(theme)=>({color:theme.palette.background.paper})}>
                        <strong>{title}</strong> 
                      </TableCell>
                    )
                  )}
                </TableRow>
              </TableHead>
              <CustomTableBody
                alert={"No records"}
                dataLoading={isLoading}
                isData={list.length > 0}
                totalSpan={{ col: heading.length, row: 10 }}
              >
                {list.map((row, index) => (
                  <TableRow
                    onClick={() => {
                      if (inEmr) {
                        row?.isCashed == 0 && handleNavigate(row);
                      } else {
                        handleNavigate(row);
                      }
                    }}
                    hover={inEmr ? row?.isCashed == 0 : true}
                    key={`emrlistId${index}`}
                    sx={{
                      "&:last-child td, &:last-child th": { border: 0 },
                      cursor: inEmr
                        ? row?.isCashed == 0
                          ? "pointer"
                          : "default"
                        : "pointer",
                    }}
                  >
                  <TableCell align="center">{searchParams.pageNumber * searchParams.pageSize + (index + 1)}</TableCell>

                    {inEmr && (
                      <TableCell>
                        {row?.isCashed == 1 && inEmr ? (
                          <span>
                            <Typography fontSize={12} color="success.main">
                              Cashed
                            </Typography>
                          </span>
                        ) : (
                          <span />
                        )}
                      </TableCell>
                    )}
                    <TableCell>{row.emrNo}</TableCell>
                    <TableCell>{row.doctorName}</TableCell>
                    <TableCell>{row.fullName}</TableCell>
                    <TableCell>{row.emiratesId}</TableCell>
                    <TableCell>{row.paymentType}</TableCell>
                   
                  </TableRow>
                ))}
              </CustomTableBody>
            </Table>
          </TableContainer>
          <div >
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={data?.response?.count || 0}
              rowsPerPage={searchParams.pageSize}
              page={searchParams.pageNumber}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </div>
        </Paper>
      </div>
    );
  };
  
  export default TriageLandingPage;
  
  const heading = [
    "SL NO",
    "EMR NO/REG NO",
    "DOCTOR",
    "PATIENT NAME",
    "QID ID",
    "PAYMENT TYPE",
  ];
  